import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList } from "vue"
import _imports_0 from '@/assets/shared/linkedin-icon.svg'
import _imports_1 from '@/assets/shared/salesforce-logo.png'


const _hoisted_1 = { class: "hover:bg-gray-50 text-left" }
const _hoisted_2 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b border-gray-200" }
const _hoisted_3 = { class: "flex flex-row gap-2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex flex-col shrink-0" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b border-gray-200" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b border-gray-200" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "px-4 py-2 font-medium text-xs leading-4 border-b border-gray-200" }
const _hoisted_22 = { class: "relative inline-block group" }
const _hoisted_23 = { class: "absolute left-1/2 -translate-x-1/2 top-full mt-1 w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none" }
const _hoisted_24 = { class: "px-4 py-2 font-medium text-xs leading-4 border-b border-gray-200" }
const _hoisted_25 = { class: "px-4 py-2 text-gray-500 font-normal leading-5 border-b border-gray-200 relative" }
const _hoisted_26 = { class: "flex justify-center items-center min-h-[32px]" }
const _hoisted_27 = {
  key: 0,
  class: "relative inline-block text-left"
}
const _hoisted_28 = ["aria-expanded"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 1,
  style: {"height":"32px"}
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  colspan: "6",
  class: "bg-gray-50 text-left border-b border-gray-200"
}
const _hoisted_36 = { class: "px-16 py-4" }
const _hoisted_37 = { class: "flex flex-row gap-8" }
const _hoisted_38 = { class: "flex flex-col gap-2" }
const _hoisted_39 = { class: "flex gap-8 max-w-max border border-gray-300 px-2 py-1 rounded-md bg-white h-full" }
const _hoisted_40 = { class: "flex items-center gap-2" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "flex flex-col text-sm text-gray-600" }
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "flex flex-col text-sm text-gray-600" }
const _hoisted_46 = { class: "flex flex-col gap-2" }
const _hoisted_47 = { class: "flex items-center gap-2 max-w-max border border-gray-300 px-2 py-1 rounded-md bg-white h-full" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "flex flex-col text-sm text-gray-600" }
const _hoisted_50 = { class: "flex flex-col gap-2" }
const _hoisted_51 = { class: "flex items-center gap-2 max-w-max border border-gray-300 px-2 py-1 rounded-md bg-white h-full" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "flex flex-wrap gap-1 text-sm text-gray-600" }
const _hoisted_54 = {
  key: 0,
  class: "text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isExpandable())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex flex-col items-center justify-center mr-2 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
              }, [
                _createElementVNode("div", {
                  innerHTML: _ctx.isExpanded ? _ctx.ARROW_UP : _ctx.ARROW_DOWN,
                  class: "w-4 h-4"
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.isInvitation && _ctx.hasProfilePicture())
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getProfilePicture(),
                  alt: "Profile Picture",
                  class: "w-10 h-10 rounded-full overflow-hidden"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: _ctx.BLANK_PROFILE_PICTURE_ICON,
                  class: "w-10 h-10 rounded-full overflow-hidden"
                }, null, 8, _hoisted_7))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isInvitation)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  (_ctx.shouldShowExpertLink())
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.getExpertCalendarUrl(),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "text-blue-600 hover:text-blue-800 hover:underline"
                      }, _toDisplayString(_ctx.getExpertName()), 9, _hoisted_10))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getExpertName()), 1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getTitle()), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isInvitation && _ctx.hasLinkedinProfile())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "object-cover shrink-0 w-6 h-6 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLinkedinClick()))
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isInvitation && _ctx.hasCrmContact())
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "flex flex-col",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCrmContact()))
              }, [
                (_ctx.getCrmType() === 'hubspot')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.HUBSPOT_LOGO_ICON,
                      class: "object-cover shrink-0 w-6 h-6 cursor-pointer mt-1"
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                (_ctx.getCrmType() === 'salesforce')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "Salesforce Logo",
                        class: "object-contain shrink-0 w-10 h-6 cursor-pointer"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("td", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", null, _toDisplayString(_ctx.getEmail()), 1)
        ])
      ]),
      _createElementVNode("td", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (!_ctx.isInvitation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "$" + _toDisplayString(_ctx.getCredits()), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, "--"))
        ])
      ]),
      _createElementVNode("td", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", {
            class: _normalizeClass(["px-2 rounded-lg", 
            _ctx.isInvitation
              ? _ctx.getInvitationStatusClass(_ctx.getStatus())
              : _ctx.getClassForStatus(_ctx.row, _ctx.originalInvitationRows)
          ])
          }, _toDisplayString(_ctx.isInvitation
              ? _ctx.invitationStatus(_ctx.getStatus())
              : _ctx.expertStatusText(
                  _ctx.getJoinProgramRequestStatus(),
                  _ctx.row,
                  _ctx.originalInvitationRows
                )), 3),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.isInvitation)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.getStatus() === "accepted"
                ? "Invitation was accepted"
                : _ctx.getStatus() === "expired"
                ? "Invitation has expired"
                : "Invited via email to join your program."), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.getStatusTooltip(
                _ctx.expertStatusText(
                  _ctx.getJoinProgramRequestStatus(),
                  _ctx.row,
                  _ctx.originalInvitationRows
                )
              )), 1)
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.isInvitation
          ? _ctx.invitationLastActivityText(_ctx.row)
          : _ctx.lastActivityText(_ctx.row, _ctx.originalInvitationRows)), 1),
      _createElementVNode("td", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (!(_ctx.isInvitation && _ctx.getStatus() === 'expired'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 focus:outline-none",
                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"])),
                  "aria-haspopup": "true",
                  "aria-expanded": _ctx.showMenu
                }, [
                  _createElementVNode("span", { innerHTML: _ctx.DOTS_VERTICAL_ICON }, null, 8, _hoisted_29)
                ], 40, _hoisted_28),
                (_ctx.showMenu)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "origin-top-right absolute right-0 mt-2 min-w-[140px] rounded-md shadow-lg bg-white border border-gray-200 ring-1 ring-black ring-opacity-5 z-50 py-1",
                      onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap overflow-hidden text-ellipsis",
                        disabled: _ctx.disableButton,
                        onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleMenuAction && _ctx.handleMenuAction(...args)))
                      }, _toDisplayString(_ctx.getActionButtonText()), 41, _hoisted_30),
                      (_ctx.showInactiveForNonAppliedUser())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "border-t border-gray-200 my-1" }, null, -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap overflow-hidden text-ellipsis",
                              disabled: _ctx.disableButton,
                              onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMakeInactiveClick && _ctx.handleMakeInactiveClick(...args)))
                            }, " Make Inactive ", 40, _hoisted_31)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.isInvitation)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "border-t border-gray-200 my-1" }, null, -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap overflow-hidden text-ellipsis",
                              disabled: _ctx.disableButton,
                              onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleCancelInvite && _ctx.handleCancelInvite(...args)))
                            }, " Cancel Invite ", 40, _hoisted_32)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 32))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_33))
        ])
      ])
    ]),
    (_ctx.isExpandable() && _ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
          _createElementVNode("td", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-sm text-left font-medium text-gray-600" }, "Meetings", -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.HAND_SHAKE_ICON,
                        class: "w-8 h-8 text-primary-purple"
                      }, null, 8, _hoisted_41),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-medium" }, "Past Meetings", -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getPastMeetingsCount()), 1)
                      ])
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "h-12 w-px bg-gray-300" }, null, -1)),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.CALENDAR_CLOCK_ICON,
                        class: "w-8 h-8 text-primary-purple"
                      }, null, 8, _hoisted_44),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-medium" }, "Future Meetings", -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getFutureMeetingsCount()), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm text-left font-medium text-gray-600" }, "Earnings", -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.DOLLAR_CIRCLE_ICON,
                      class: "w-8 h-8 text-primary-purple"
                    }, null, 8, _hoisted_48),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "font-medium" }, "Total Earnings", -1)),
                      _createElementVNode("span", null, "$" + _toDisplayString(_ctx.getTotalEarnings()), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-sm text-left font-medium text-gray-600" }, "Tags", -1)),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.STARS_ICON,
                      class: "w-8 h-8 text-primary-purple"
                    }, null, 8, _hoisted_52),
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectedExpertTags(), (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: tag,
                          class: "px-2 py-1 bg-gray-100 rounded-md text-xs"
                        }, _toDisplayString(tag), 1))
                      }), 128)),
                      (_ctx.getSelectedExpertTags().length === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, " No tags selected "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.successMessage || _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
      'mt-2 text-xs px-3 py-2 rounded',
      _ctx.messageType === 'success'
        ? 'bg-green-100 text-green-800'
        : 'bg-red-100 text-red-800',
    ])
        }, _toDisplayString(_ctx.successMessage || _ctx.errorMessage), 3))
      : _createCommentVNode("", true)
  ], 64))
}